<template>
  <div class="main-container">
    <h1>Payment Details Page</h1>
    <p id="noRecordsMessage">Welcome to the future home of the payment details page.</p>
  </div>
</template>

<script>
  export default {
    name: "EditPaymentDetail",
    data() {
      return {
        cardNumber: "",
        expiryDate: "",
      };
    },
    methods: {
      updatePaymentDetails() {
        alert("Payment details updated!");  // Placeholder for actual update logic
      },
    },
  };
  </script>

<style scoped>
.main-container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
  text-align: center;
}

#noRecordsMessage {
  margin-top: 20px;
  text-align: center;
  color: var(--text-primary);
}
</style>

  